import { User } from '../types/index';
import { isValidTokenFormat, isTokenExpired } from './tokenUtils';

// Keys for storing authentication data in localStorage
const TOKEN_KEY = 'moftah_auth_token';
const USER_KEY = 'user_data';

// Store the authentication token
export const setToken = (token: string): void => {
  if (!token || !isValidTokenFormat(token)) {
    console.error('Invalid token format. Not storing token.');
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
};

// Get the authentication token
export const getToken = (): string | null => {
  const token = localStorage.getItem(TOKEN_KEY);
  
  // Debug log
  console.log('getToken retrieved from key:', TOKEN_KEY, token ? `${token.substring(0, 15)}...` : 'null');
  
  // Validate token is still valid
  if (token && isTokenExpired(token)) {
    console.log('Token is expired. Removing token.');
    removeToken();
    return null;
  }
  
  return token;
};

// Remove the authentication token
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

// Store user data
export const setUserData = (user: User): void => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

// Get user data
export const getUserData = (): User | null => {
  const userData = localStorage.getItem(USER_KEY);
  return userData ? JSON.parse(userData) : null;
};

// Remove user data
export const removeUserData = (): void => {
  localStorage.removeItem(USER_KEY);
};

// Handle login success - store both token and user data
export const handleLoginSuccess = (token: string, user: User): void => {
  if (!token || !isValidTokenFormat(token)) {
    console.error('Invalid token received from login.');
    return;
  }
  
  setToken(token);
  setUserData(user);
};

// Handle logout - clear both token and user data
export const logout = (): void => {
  removeToken();
  removeUserData();
};

// Check if the user is authenticated
export const isAuthenticated = (): boolean => {
  const token = getToken();
  return !!token && !isTokenExpired(token);
}; 